export const MediatorEventType = "CROSS_PRODUCT_CLICK";

export interface EventData {
  type: typeof MediatorEventType;
  payload: { module: string; destinationUrl: string; eventLabel: string };
}
